/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import clsx from "clsx";
import { RefObject } from "react";

import { Displayer, Icon, Link } from "@smart/itops-sb-design-system-dom";
import { specialChars } from "@smart/itops-utils-basic";

import { FieldError, GroupError } from "../../types";

type Error = { onClick?: () => void } & (FieldError | GroupError);

export const SingleError = ({
  name,
  label,
  index,
  error,
  fieldErrors,
  onClick,
}: Error) => (
  <li className="my-[0.4rem]" key={name} onClick={onClick} onKeyDown={() => {}}>
    <label
      className={clsx(
        "underline text-neutral-750",
        !fieldErrors && "cursor-pointer",
      )}
      htmlFor={name}
    >
      <Displayer
        paragraphTag="span"
        value={label}
        hintElement={
          index !== undefined &&
          fieldErrors?.length &&
          fieldErrors.length > 1 && (
            <span>
              {specialChars.nbsp}
              {index + 1}
            </span>
          )
        }
      />
    </label>
    : {error}
    {!!fieldErrors && (
      <ul>
        {fieldErrors.map((err) => (
          <SingleError key={err.name} {...err} />
        ))}
      </ul>
    )}
  </li>
);

type ErrorSummaryProps = {
  errors: Error[];
  errorsRef?: RefObject<HTMLDivElement>;
};

export const ErrorSummary = ({ errors, errorsRef }: ErrorSummaryProps) => {
  if (!errors.length) return null;

  return (
    <div
      className="flex flex-col bg-red-50 rounded p-[1.6rem] mt-[0.8rem] border-l-4 border-red-650"
      data-testid="error-summary"
    >
      <p
        className="flex items-center gap-medium text-red-650 text-paragraph"
        ref={errorsRef}
        tabIndex={0}
      >
        <Icon name="solidDiamondExclamation" />
        Please correct the following {errors.length} errors:
      </p>
      <div className="text-ui ml-[3.2rem] mt-[0.8rem]">
        <ul>
          {errors.map((err) => (
            <SingleError key={err.name} {...err} />
          ))}
        </ul>
        {errors[0].onClick && (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <Link
            className="mt-[0.8rem]"
            text="Go to first error"
            onClick={() => errors[0].onClick!()}
          />
        )}
      </div>
    </div>
  );
};
